import SecondaryDialogButton from './SecondaryDialogButton';
export default SecondaryDialogButton;